const introTextBlock = {
  displayField: 'header',
  name: 'Intro Text Block',
  description: 'Contentful schema for Intro Text Block',
  fields: [
    {
      id: 'eyebrow',
      name: 'Optional eyebrow text that appears above header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header text for Intro Text Block',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body text for Intro Text Block',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'swatch',
      name: 'Optional swatch, either default or "green"',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'introTextBlock',
    version: 26,
    updatedAt: '2023-08-02T22:06:35.488Z'
  }
};
export default introTextBlock;